<script lang="ts" setup>
import FilterTable from "@/components/Common/Table/FilterTable.vue";
import { ref } from "vue";
import type { Header } from "vue3-easy-data-table";
import EasyDataTable from "vue3-easy-data-table";
import "vue3-easy-data-table/dist/style.css";
import Swal from "sweetalert2";
import router from "@/router";
import BaseLoading from "@/components/Common/BaseLoading.vue";
import { toast } from "vue-sonner";
import { useVarianStore } from "@/stores/management/varian";

const linkAdd = {
  text: "Add Goods/Item Varian",
  url: "/management/varian/create",
};

const headers: Header[] = [
  { text: "Goods", value: "goods" },
  { text: "MSG CODE", value: "msg_code" },
  { text: "IMPA CODE", value: "impa_code" },
  { text: "TYPE", value: "name" },
  { text: "VALUE", value: "size" },
  { text: "ACTIONS", value: "action" },
];

const varianStore = useVarianStore();
const page = ref<number>(1);
const limit = ref<number>(10);
const totalItems = ref<number>(0);
const listVarians = ref<any>([]);
const isLoading = ref(false);

const loadDataVarians = async (query = "") => {
  isLoading.value = true;
  const { success, message } = await varianStore.dispatchGetAll(
    page.value,
    limit.value,
    query
  );
  if (success) {
    listVarians.value = await varianStore.varians.items;
    page.value = await varianStore.varians.page;
    limit.value = await varianStore.varians.pageSize;
    totalItems.value = await varianStore.varians.total;
  }
  isLoading.value = false;
};

const handleServerOptionsUpdate = (options: {
  page: number;
  rowsPerPage: number;
}) => {
  page.value = options.page;
  limit.value = options.rowsPerPage;
  loadDataVarians();
};

const handleEdit = (item: any) => {
  router.push("/management/varian/" + item);
};

const handleDelete = async (item: any) => {
  const swalWithBootstrapButtons = Swal.mixin({
    customClass: {
      cancelButton: "btn btn-danger",
      confirmButton: "btn btn-success",
    },
    buttonsStyling: false,
  });
  swalWithBootstrapButtons
    .fire({
      title: `Are you sure want to delete data ${item.name} ?`,
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel!",
      reverseButtons: true,
    })
    .then(async (result) => {
      if (result.isConfirmed) {
        const { success, message } = await varianStore.dispatchDelete(item.id);
        if (success) {
          swalWithBootstrapButtons.fire({
            title: "Deleted!",
            text: "Your file has been deleted.",
            icon: "success",
          });
          loadDataVarians();
        } else {
          toast.error(message);
        }
      } else if (
        /* Read more about handling dismissals below */
        result.dismiss === Swal.DismissReason.cancel
      ) {
        swalWithBootstrapButtons.fire({
          title: "Cancelled",
          text: "Your action has been aborted",
          icon: "error",
        });
      }
    });
};

loadDataVarians();
</script>
<template>
  <div class="card bg-white border-0 rounded-3 mb-4">
    <div class="card-body p-4">
      <div
        class="d-flex justify-content-between align-items-center flex-wrap gap-3 mb-3 mb-lg-4"
      >
        <h3 class="mb-0">List Data Item Varian</h3>
      </div>
      <FilterTable :link="linkAdd" @searchByQuery="loadDataVarians" />
      <div class="table-content">
        <BaseLoading v-if="isLoading" />
        <EasyDataTable
          :headers="headers"
          :items="listVarians"
          v-if="!isLoading"
          show-index
          :server-options="{
            page: page,
            rowsPerPage: limit,
          }"
          :server-items-length="totalItems"
          @update:server-options="handleServerOptionsUpdate"
          buttons-pagination
        >
          <template #item-image="props">
            <img :src="props.image_link" alt="image-link" class="image-item" />
          </template>
          <template #item-action="props">
            <div class="d-flex gap-2">
              <button
                class="btn btn-danger btn-sm"
                @click="handleDelete(props)"
              >
                Delete
              </button>
            </div>
          </template>
        </EasyDataTable>
      </div>
    </div>
  </div>
</template>
<style>
.image-item {
  width: 200px;
  height: auto;
  object-fit: contain;
  padding: 10px;
}
</style>
